var React = require('react');

function Footer (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"opacity":"0.2","fill":"#FFFFFF","points":"0,0 0,559.7 283.4,0 "}));
}

Footer.defaultProps = {"focusable":"false","viewBox":"0 0 283.4 559.7","preserveAspectRatio":"xMinYMin meet"};

module.exports = Footer;

Footer.default = Footer;
